import React from 'react';
import { useObservable } from 'react-use-observable';

import { FilterOutlined } from '@ant-design/icons';
import { Row, Col, Button, Spin } from 'antd';

import isAfter from 'date-fns/isAfter';
import startOfDay from 'date-fns/startOfDay';
import { Form as FormikForm, Field, useFormikContext } from 'formik';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import { ECustomerSearchTypes } from 'v2/interfaces/reports/partnerCommissions';
import type { IPartnerCommissionFilter } from 'v2/interfaces/reports/partnerCommissions';
import { initialFilter, partnerCommissionsService } from 'v2/services/reports/partnerCommissions';

const customerTypes = [
  { label: 'E-mail', value: ECustomerSearchTypes.EMAIL },
  { label: 'Nome', value: ECustomerSearchTypes.NAME }
];

export const Form = () => {
  const { values, setFieldValue, isValid, isSubmitting, resetForm, dirty } =
    useFormikContext<IPartnerCommissionFilter>();

  const [isLoading] = useObservable(() => partnerCommissionsService.isLoading(), []);

  const isOutsideRange = (day: Date) => isAfter(startOfDay(day), startOfDay(new Date()));

  const onChangeCustomerType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue('commissioned', '');
    setFieldValue('commissioned_type', e.target.value);
  };

  const handleClean = () => {
    resetForm({ values: initialFilter });
  };

  const customerLabel = values.commissioned_type === ECustomerSearchTypes.NAME ? 'Nome' : 'E-mail';
  const customerPlaceholder =
    values.commissioned_type === ECustomerSearchTypes.NAME ? 'Insira o nome' : 'Insira o e-mail';

  const isFilterDisabled = !isValid || isSubmitting || isLoading;
  const isCleanDisabled = !dirty || isSubmitting || isLoading;

  return (
    <FormikForm>
      <div id='commissions-paid-to-partners' className='mb-4 flex w-full max-sm:flex-wrap'>
        <Row gutter={[16, 16]} className='flex-1'>
          <Col xs={24} sm={12} lg={6}>
            <Field
              label='Período'
              id='date'
              name='date'
              component={DateRangePickerFormField}
              isPresetLonger
              isOutsideRange={isOutsideRange}
            />
          </Col>
          <Col xs={24} sm={12} lg={10}>
            <Row gutter={[4, 4]}>
              <Col span={8}>
                <Field
                  id='commissioned_type'
                  name='commissioned_type'
                  label='Parceiro'
                  options={customerTypes}
                  onChange={onChangeCustomerType}
                  component={SelectFormField}
                  fullWidth
                />
              </Col>
              <Col span={16}>
                <Field
                  id='commissioned'
                  name='commissioned'
                  label={customerLabel}
                  placeholder={customerPlaceholder}
                  component={TextFormField}
                  fullWidth
                />
              </Col>
            </Row>
          </Col>
          <Col xs={12} lg={4} className='lg:pt-5'>
            <Button id='clean-filter-button' block onClick={handleClean} type='text' disabled={isCleanDisabled}>
              Limpar
            </Button>
          </Col>
          <Col xs={12} lg={4} className='lg:pt-5'>
            <Button
              block
              id='filter-button'
              type='primary'
              disabled={isFilterDisabled}
              htmlType='submit'
              icon={
                isSubmitting || isLoading ? (
                  <Spin size='small' />
                ) : (
                  <FilterOutlined className='mr-0' style={{ fontSize: 14 }} />
                )
              }
            >
              Filtrar
            </Button>
          </Col>
        </Row>
      </div>
    </FormikForm>
  );
};
